import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import useDisplay from "../../hooks/useDisplay";
import styled from "styled-components";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH2HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import { route } from "../../router/route";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSBdBody01 from "./../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import Pagination from "./../../components/molecules/pagination";
import { activitySubTabList, tabList } from "./../../constant/myPageTab";
import MOContainer from "../../components/atoms/layout/moContainer";
import SelectBox from "../../components/organisms/SelectBox";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import LSBdCaption01 from "../../components/molecules/text/linSeedKr/Bd/lsBdCaption01";
import LSRgCaption01 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption01";
import CommunityApi from "../../api/community.api";
import { formatNumberWithCommas } from "./../../util/formatNumber";
import Empty from "../../components/molecules/empty";
import { macOSCheck } from "../../util/macOSCheck";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import StyledSubCategoryItem from "../../components/molecules/button/styledSubCategoryItem";
import Loading from "../../components/templates/loading";
import { errorHandler } from "../../util/errorHandler";
import { toast } from "react-toastify";

const MyPageActivity = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line
  const location = useLocation();

  // ---------- 모바일 버전 탭 관련 ---------- //
  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(tabList[1].title);

  const [selectedSubMenuTabOpen, setSelectedSubMenuTabOpen] = useState(false);
  const [selectedSubMenuTab, setSelectedSubMenuTab] = useState(
    activitySubTabList[0].title,
  );

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(route.my_page_activity)}`,
        { replace: true },
      );
      return;
    }

    getPostList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 페이지네이션 관련 ---------- //
  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page"));
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 1,
  });

  // ---------- 게시글 리스트 가져오기 ---------- //
  const [postList, setPostList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getPostList = async () => {
    if (sessionStorage.getItem("isLogin") !== "true") return;

    try {
      setIsLoading(true);
      const data = {
        page: page || 1,
        size: pagination.size,
        myPostFlag: "Active",
      };
      const response = (await CommunityApi.getList(data)).data.data;

      setPostList(response?.content ?? []);

      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages:
          response.totalPage ||
          Math.max(1, Math.ceil(response.totalCount / prev.size)),
      }));
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              color: "#000",
              marginBottom: 32,
            }}
          >
            👨‍💻 마이페이지
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {tabList.map((tab, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  <StyledCategoryItem
                    onClick={() => navigate(tab.path)}
                    isActive={index === 1 ? true : false}
                    title={tab.title}
                  />

                  {index === 1 && (
                    <SubTabWrapper>
                      {activitySubTabList.map((subTab, index) => (
                        <StyledSubCategoryItem
                          key={index}
                          onClick={() => {
                            navigate(subTab.path);
                          }}
                          title={subTab.title}
                          isActive={index === 0 ? true : false}
                        />
                      ))}
                    </SubTabWrapper>
                  )}
                </div>
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 30,
              }}
            >
              <ContentContainer>
                <ContentHeaderWrapper>
                  <LSRgDisplay02 style={{ color: "#000" }}>
                    내가 쓴 글
                  </LSRgDisplay02>
                  <LSRgH2HeadLine style={{ color: "#000" }}>
                    이용 정책에 어긋나는 게시글은 삭제 처리될 수 있어요.
                  </LSRgH2HeadLine>
                </ContentHeaderWrapper>

                {/* 본문 영역 - 테이블 */}
                <Table>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan={5}>
                          <Loading />
                        </td>
                      </tr>
                    ) : postList.length > 0 ? (
                      postList.map((item, index) => (
                        <Tr
                          key={item.id}
                          style={{
                            borderTop: index === 0 && "1px solid #dbdde0",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigate(`${route.community_detail}/${item.id}`);
                          }}
                        >
                          <td style={{ marginRight: 10 }}>
                            <Category>
                              <LSBdBody01 style={{ color: "#5050FF" }}>
                                {item?.communityCategory?.title || ""}
                              </LSBdBody01>
                            </Category>
                          </td>
                          <td
                            style={{
                              marginRight: 127,
                            }}
                          >
                            <LSRgH2HeadLine
                              style={{
                                color: "#101113",
                                width: 459,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item?.title || ""}
                            </LSRgH2HeadLine>
                          </td>
                          <td
                            style={{
                              minWidth: 145,
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              marginRight: 17,
                            }}
                          >
                            <img
                              style={{
                                width: 18,
                                height: 18,
                                objectFit: "cover",
                              }}
                              src={"/assets/icons/user.png"}
                              alt={"작성자"}
                            />
                            <LSRgBody01 style={{ color: "#898E99" }}>
                              {item?.member?.nickname || ""}
                            </LSRgBody01>
                          </td>
                          <td
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              minWidth: 60,
                              marginRight: 16,
                            }}
                          >
                            <img
                              style={{
                                width: 18,
                                height: 18,
                                objectFit: "cover",
                              }}
                              src={"/assets/icons/view.png"}
                              alt={"조회수"}
                            />
                            <LSRgBody01 style={{ color: "#898E99" }}>
                              {formatNumberWithCommas(item?.viewCount) || 0}
                            </LSRgBody01>
                          </td>
                          <td
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              marginRight: 8,
                              minWidth: 60,
                            }}
                          >
                            <img
                              style={{
                                width: 18,
                                height: 18,
                                objectFit: "cover",
                              }}
                              src={"/assets/icons/comment.png"}
                              alt={"댓글수"}
                            />
                            <LSRgBody01 style={{ color: "#898E99" }}>
                              {formatNumberWithCommas(item?.commentCount) || 0}
                            </LSRgBody01>
                          </td>
                        </Tr>
                      ))
                    ) : (
                      <Empty title="내가 쓴 글이 없습니다." />
                    )}
                  </tbody>
                </Table>

                {postList.length > 0 && pagination.totalCount > 10 && (
                  <Pagination
                    route={route.my_page_activity}
                    queryString={``}
                    currentPage={Number(page) || 1}
                    totalPages={pagination.totalPages}
                    rangeSize={pagination.rangeSize}
                  />
                )}
              </ContentContainer>
            </div>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isMobile && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>👨‍💻 마이페이지</LSRgH1HeadLine>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={subMenuBoxOpen}
                  isLink={true}
                  selectedValue={selectedSubMenu}
                  wrapperHandler={() => {
                    setSubMenuBoxOpen(!subMenuBoxOpen);
                  }}
                  itemList={tabList}
                  selectedValueSetterFunc={setSelectedSubMenu}
                />

                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={selectedSubMenuTabOpen}
                  isLink={true}
                  selectedValue={selectedSubMenuTab}
                  wrapperHandler={() => {
                    setSelectedSubMenuTabOpen(!selectedSubMenuTabOpen);
                  }}
                  itemList={activitySubTabList}
                  selectedValueSetterFunc={setSelectedSubMenuTab}
                />
              </div>
            </ContentHeaderWrapper>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                marginBottom: 20,
              }}
            >
              <LSRgH1HeadLine style={{ color: "#000" }}>
                내가 쓴 글
              </LSRgH1HeadLine>
              <LSRgCaption02 style={{ color: "#898e99" }}>
                이용 정책에 어긋나는 게시글은 삭제 처리될 수 있어요.
              </LSRgCaption02>
            </div>

            {/* 본문 영역 - 테이블 */}
            <Table $isSmall={isSmall}>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td>
                      <Loading />
                    </td>
                  </tr>
                ) : postList.length > 0 ? (
                  postList.map((item, index) => (
                    <Tr
                      key={item.id}
                      $isSmall={isSmall}
                      style={{
                        borderTop: index === 0 && "1px solid #dbdde0",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        navigate(`${route.community_detail}/${item.id}`);
                      }}
                    >
                      <td
                        style={{
                          display: "flex",
                          width: 315,
                          flexDirection: "column",
                          gap: 10,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: 10,
                          }}
                        >
                          <Category $isSmall={isSmall}>
                            <LSBdCaption01
                              style={{
                                color: "#5050FF",
                              }}
                            >
                              {item?.communityCategory?.title || ""}
                            </LSBdCaption01>
                          </Category>
                          <LSRgBody01
                            style={{
                              maxWidth: 247,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              WebkitLineClamp: 2, // 2줄부터 ... 표시
                              minHeight: isMobile ? 39.19 : "auto",
                              marginTop: macOSCheck() ? 0 : 2,
                            }}
                            onClick={() => {}}
                          >
                            {item?.title || ""}{" "}
                          </LSRgBody01>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            paddingLeft: 68,
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <img
                              style={{
                                width: 14,
                                height: 14,
                                objectFit: "cover",
                              }}
                              src={"/assets/icons/user.png"}
                              alt={"작성자"}
                            />
                            <LSRgCaption01
                              style={{
                                width: 86,
                                color: "#898E99",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item?.member?.nickname || ""}
                            </LSRgCaption01>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <img
                              style={{
                                width: 14,
                                height: 14,
                                objectFit: "cover",
                              }}
                              src={"/assets/icons/view.png"}
                              alt={"조회수"}
                            />
                            <LSRgCaption01 style={{ color: "#898E99" }}>
                              {formatNumberWithCommas(item?.viewCount) || 0}
                            </LSRgCaption01>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <img
                              style={{
                                width: 14,
                                height: 14,
                                objectFit: "cover",
                              }}
                              src={"/assets/icons/comment.png"}
                              alt={"댓글수"}
                            />
                            <LSRgCaption01 style={{ color: "#898E99" }}>
                              {formatNumberWithCommas(item?.commentCount) || 0}
                            </LSRgCaption01>
                          </div>
                        </div>
                      </td>
                    </Tr>
                  ))
                ) : (
                  <Empty title="내가 쓴 글이 없습니다." />
                )}
              </tbody>
            </Table>

            {postList.length > 0 && pagination.totalCount > 10 && (
              <Pagination
                route={route.my_page_activity}
                queryString={``}
                currentPage={Number(page) || 1}
                totalPages={pagination.totalPages}
                rangeSize={pagination.rangeSize}
              />
            )}
          </ContentContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default MyPageActivity;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SubTabWrapper = styled.div.attrs((props) => {})`
  width: 175px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -6px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "16px" : "4px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const Table = styled.table.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  border-spacing: 0px;
  border-collapse: collapse;
`;

const Tr = styled.tr.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: ${(props) => (props.$isSmall ? "96px" : "64px")};
  border-bottom: 1px solid #dbdde0;
  padding: 16px 10px;
  display: flex;
  align-items: center;
`;

const Category = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "58px" : "89px")};
  height: ${(props) => (props.$isSmall ? "24px" : "32px")};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  border: 1px solid #5050ff;
`;
